export default __webpack_public_path__ + "static/media/day4.f3046553.png";